import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SendEmailRequest } from '../sendgrid-email.model';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SendGridEmailService {

  constructor(
    private http: HttpClient
  ) { }

  public sendEmail(payload: SendEmailRequest): Observable<void> {
    return this.http.post<void>(`${environment.apiEndpoint}/api/v1/payment-links/send`, payload);
  }
}
